module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.d4ed4e12.svg";